import React, { Component } from 'react'
import _ from 'lib/lodash'

import Button from 'react-md/lib/Buttons/Button'
import Toolbar from 'react-md/lib/Toolbars'

import './BundleHeader.css'
import { withRouter } from 'react-router-dom'

class BundleHeader extends Component {

	handleButtonHome = () => {
		this.props.history.push('/home');
	};

	render() {
		const { bundle } = this.props;

		const title = _.get(bundle, 'properties.title');

		const toolbarNav = (
			<div>
				<Button onClick={this.handleButtonHome}icon>home</Button>
			</div>
		);

		const renderTitle = (
			<div>
				{ title || "Smart Sticker Bundle" }
			</div>
		);

		return (
			<div>
				<Toolbar
					className="bundle-toolbar"
					colored
					fixed
					nav={toolbarNav}
					title={renderTitle}
					zDepth={0}
				/>
			</div>
		);
	}
}

export default withRouter(BundleHeader)


// WEBPACK FOOTER //
// ./src/components/bundle/v1/BundleHeader.jsx